/*global VXConfig*/
import React                from 'react';
import PropTypes            from 'prop-types';
import ContestVoting        from './ContestVoting';
import Flux                 from '../flux/Flux';
import {formatCurrency}     from '../utils/CommonUtils';
import Translations         from '../utils/Translations';
import {isMobileRequest}    from '../utils/CommonUtils';
import {updateURLParameter} from "../utils/CommonUtils";
import HistoryStateHelper   from "../utils/HistoryStateHelper";

const VIDEO                     = 'video';
const PHOTO                     = 'photo';
const CONTEST_ITEM_URL_PARAM    = 'mediaIndex';
const STATE_OBJECT_URL_PROPERTY = 'url';

class ContestGridItem extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			contestVotes:    this.props.contestVotes,
			isElementPinned: this.props.isElementPinned,
		};

		this.onAlbumPinStatus    = this.onAlbumPinStatus.bind(this);
		this.onPicturePinStatus  = this.onPicturePinStatus.bind(this);
		this.onContestItemChange = this.onContestItemChange.bind(this);
		this.onImageItemClick    = this.onImageItemClick.bind(this);
		this.onImageLoad         = this.onImageLoad.bind(this);
	}

	componentDidMount() {
		Flux.Contest.addContestVotingChangeListener(this.onContestItemChange);
		if (this.props.mediaType === VIDEO) {
			Flux.Favorite.addAlbumPinStatusListener(this.onAlbumPinStatus);
		} else if (this.props.mediaType === PHOTO) {
			Flux.Favorite.addPicturePinStatusListener(this.onPicturePinStatus);
		}
		if (this.props.openMedia) {
			const event = {};
			this.onImageItemClick(event);
		}
	}

	componentWillUnmount() {
		Flux.Contest.removeContestVotingChangeListener(this.onContestItemChange);
		if (this.props.mediaType === VIDEO) {
			Flux.Favorite.removeAlbumPinStatusListener(this.onAlbumPinStatus);
		} else if (this.props.mediaType === PHOTO) {
			Flux.Favorite.removePicturePinStatusListener(this.onPicturePinStatus);
		}
	}

	onAlbumPinStatus(albumId, status) {
		if (albumId === this.props.albumId) {
			this.setState({isElementPinned: status});
		}
	}

	onPicturePinStatus(pictureId, status) {
		if (pictureId === this.props.mediaId) {
			this.setState({isElementPinned: status});
		}
	}

	onContestItemChange(guestId, contestId, mediaId) {
		if (guestId === this.props.guestId &&
			contestId === this.props.contestId &&
			mediaId === this.props.mediaId
		) {
			const mediaVotings = Flux.Contest.getContestVoting(this.props.mediaId);
			this.setState({
				contestVotes: mediaVotings,
			});
		}
	}

	onImageItemClick(e) {
		const href = updateURLParameter(window.location.href, CONTEST_ITEM_URL_PARAM, this.props.mediaId);
		HistoryStateHelper.setValue(STATE_OBJECT_URL_PROPERTY, href, document.title, href);
		this.props.onImageClick(e, this.props.imageIndex, this.props.mediaType, this.state.isElementPinned);
		this.props.onImageClick(e, this.props.imageIndex, this.props.mediaType, this.state.isElementPinned, this.props.isOver18Content);

	}

	onImageLoad() {
		if (this.props.onImageLoad) {
			this.props.onImageLoad();
		}
	}

	render() {
		let footerPlateClass = '';
		if (VXConfig.isVXMobilePlatform) {
			footerPlateClass = ' -is-mobile';
		}

		const actorName        = <span className="contents__plate-actorname">{this.props.actorName}</span>;
		const actorNameMobile  = <div className={"contents__plate-actorname" + footerPlateClass}>
			<span>{this.props.actorName}</span>
			{this.props.actorAge > 0 && <span className="contents__plate-actorage">({this.props.actorAge})</span>}
		</div>;
		const albumTitle       = <span className="contents__plate-albumtitle" dangerouslySetInnerHTML={{ __html: this.props.albumTitle }}/>;
		let fixedVideoHeight   = '';
		let actorNameContainer = actorName;

		if(VXConfig.isVXMobilePlatform){
			actorNameContainer = actorNameMobile;
		}

		if (this.props.mediaType === VIDEO) {
			actorNameContainer = <div className="contents__plate-detailscontainer -video">
				{albumTitle}
				<span className="contents__plate-duration">({this.props.videoDuration} min) </span>
				{actorName}
			</div>;
			if (isMobileRequest()) {
				fixedVideoHeight = ' -fixed-height';
			}
		}

		if (this.props.mediaType === PHOTO) {
			actorNameContainer = <div className="contents__plate-detailscontainer-photo">
				{actorName}
				{this.props.actorAge && <span className="contents__plate-actorage">({this.props.actorAge})</span>}
			</div>;
		}

		// center no avs placeholder picture on mobile
		let placeholderClass = '';
		if (VXConfig.isVXMobilePlatform && this.props.contestPreviewImgs[0].isNoAvsPlaceholder) {
			placeholderClass = ' -is-placeholder';
		}

		let priceBadge = '';
		if (Flux.Guest.isLoggedIn() && (this.props.mediaPrice > 0 && this.props.needsBuying)) {
			if (this.props.crossPriceBadge) {
				priceBadge =
					<span className="badge--normal h-text-highlight" dangerouslySetInnerHTML={{__html: this.props.crossPriceBadge}} />;
			} else {
				priceBadge = <span className="badge--normal">{formatCurrency(this.props.mediaPrice)}</span>;
			}
		}

		const content =
			      <div id={'contest-image-' + this.props.mediaId} onClick={this.onImageItemClick}
			           className={"contests__image-container" + (VXConfig.isVXMobilePlatform ? '' : fixedVideoHeight) + " h-cursor-pointer" + ((this.props.mediaType === VIDEO) ? ' -fixed-ratio' : '') + placeholderClass}
			      >
				      <img className={"contests__actorimg" + placeholderClass + (VXConfig.isVXMobilePlatform ? '' : fixedVideoHeight)}
				           src={this.props.contestPreviewImgs[0].url}
				           onLoad={this.onImageLoad}
				           onError={this.onImageLoad}
				      />
				      {this.props.contestPlace < 4 &&
				      <span className={"contents__placing icon-actor -icon-award-user-ranking-" + this.props.contestPlace} />
				      }
				      {this.props.mediaType === VIDEO &&
				      <div className="badge-container">
					      {Flux.Guest.isLoggedIn() && this.props.isVIP &&
					      <span className="badge--special"><i className='icon -icon-person-vip' /> VIP</span>
					      }
					      {this.props.isOver18Content &&
					      <span className="badge--highlight">{Translations.get('Over18')}</span>
					      }
					      {priceBadge}
					      {Flux.Guest.isLoggedIn() && (this.props.mediaPrice === 0 && !this.props.needsBuying) &&
					      <span className="badge--normal">{Translations.get('FreeClip')}</span>
					      }
				      </div>
				      }
				      <div className={"contents__plate" + placeholderClass + footerPlateClass}>
					      {actorNameContainer}
					      {(this.state.contestVotes > 0 && this.props.isVotingAllowed) &&
					      <span className="contents__plate-actorvotes">{this.state.contestVotes}</span>}
					      {(this.props.isVotingAllowed || this.props.isVoted || this.state.contestVotes > 0) && <ContestVoting
						      contestId={this.props.contestId}
						      actorId={this.props.actorId}
						      mediaId={this.props.mediaId}
						      guestId={this.props.guestId}
						      isVoted={this.props.isVoted}
						      albumId={this.props.albumId}
						      isVotingAllowed={this.props.isVotingAllowed}
						      mediaType={this.props.mediaType}
						      currentPage={this.props.currentPage}
						      key={this.props.mediaId + 'griditem'}
						      styleClass="h-right"
					      />}
					      {(this.state.contestVotes > 0 && !this.props.isVotingAllowed) &&
						      <span className="contents__plate-actorvotes">{this.state.contestVotes}</span>}
				      </div>
			      </div>;

		let result;

		if (this.props.mediaType === VIDEO) {
			result = <a className="contests__shoplink" href={this.props.shopUrl}>{content}</a>;
		} else {
			result = content;
		}

		if(this.props.actorName.length > 0) {
			return (
				result
			);
		}
		return null;
	}
}

ContestGridItem.propTypes = {
	actorId:            PropTypes.number.isRequired,
	actorName:          PropTypes.string.isRequired,
	actorAge:           PropTypes.number.isRequired,
	albumId:            PropTypes.number.isRequired,
	albumTitle:         PropTypes.string.isRequired,
	contestId:          PropTypes.number.isRequired,
	contestPlace:       PropTypes.number,
	contestPreviewImgs: PropTypes.arrayOf(PropTypes.string).isRequired,
	contestVotes:       PropTypes.number.isRequired,
	guestId:            PropTypes.number,
	isVoted:            PropTypes.bool.isRequired,
	mediaId:            PropTypes.number.isRequired,
	onImageClick:       PropTypes.func,
	onImageLoad:        PropTypes.func,
	isVotingAllowed:    PropTypes.bool,
	imageIndex:         PropTypes.number,
	mediaType:          PropTypes.string,
	isElementPinned:    PropTypes.bool,
	videoDuration:      PropTypes.number,
	shopUrl:            PropTypes.string,
	mediaPrice:         PropTypes.number,
	isVIP:              PropTypes.bool,
	isOver18Content:    PropTypes.bool,
	needsBuying:        PropTypes.bool,
	currentPage:        PropTypes.number,
	openMedia:          PropTypes.bool,
	crossPriceBadge:    PropTypes.string,
};

ContestGridItem.defaultProps = {
	actorId:            0,
	actorName:          '',
	actorAge:           0,
	albumId:            0,
	albumTitle:         '',
	contestId:          0,
	contestPlace:       0,
	contestPreviewImgs: [],
	contestVotes:       0,
	guestId:            0,
	isVoted:            false,
	mediaId:            0,
	onImageClick:       () => {
	},
	isVotingAllowed:    true,
	imageIndex:         0,
	mediaType:          '',
	isElementPinned:    false,
	videoDuration:      0,
	shopUrl:            '',
	mediaPrice:         0,
	isVIP:              false,
	isOver18Content:    false,
	needsBuying:        false,
	onImageLoad:        null,
	currentPage:        null,
	crossPriceBadge:    '',
};

export default ContestGridItem;
